// app/constants.ts
import { Dimensions, StyleSheet } from 'react-native';
import { CompanyFormData, VehicleFormData, OdometerFormData } from './types';


export const { width: SCREEN_WIDTH, height: SCREEN_HEIGHT } = Dimensions.get('window');

export const STYLES = {
  dashboardContainer: { flex: 1, width: '100%', height: '100%' },
  map: { width: '100%', height: SCREEN_HEIGHT * 0.4 },
  scrollContent: { flexGrow: 1, padding: 16 },
  fab: { position: 'absolute', margin: 16, top: 0, left: 0 },
  centeredView: { flex: 1, justifyContent: 'center', alignItems: 'center' },
  drivingTimeSurface: {
    padding: 10,
    borderRadius: 16,
    flexDirection: 'row',
    alignItems: 'center',
    width: '90%',
    marginBottom: 20,
  },
  buttonContainer: { width: '90%', alignItems: 'center' },
};

export const FORM_DEFAULTS: {
  COMPANY: CompanyFormData;
  VEHICLE: VehicleFormData;
  ODOMETER: OdometerFormData;
} = {
  COMPANY: { company_name: '', company_nipc: '', company_email: '' },
  VEHICLE: { registration_number: '', fuel_type: 'gasolina', make: '', model: '', year: new Date().getFullYear() },
  ODOMETER: { odometer: 0 },
};

export const FUEL_TYPE_OPTIONS = [
  { value: 'gasolina' as const, label: 'Gasolina' },
  { value: 'gasoleo' as const, label: 'Gasóleo' },
  { value: 'bifuel' as const, label: 'Bi-fuel' },
  { value: 'hibrido' as const, label: 'Híbrido' },
  { value: 'eletrico' as const, label: 'Elétrico' },
] as const;

export const POLL_INTERVAL = 30000; // Polling interval in milliseconds